import TabPanel from './TabPanel';
export * from './TabPanel';
export default TabPanel;
